import { Typography, Container, List, ListItem } from "@mui/material";

import {
  collection,
  getDocs,
  doc,
  query,
  where,
  limit,
} from "firebase/firestore";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { db } from "../firebase.config";
import { toast } from "react-toastify";
import Slider from "react-slick";

// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Spinner from "../components/Spinner.jsx";

function Explore(props) {
  const { genres } = props;
  const [loading, setLoading] = useState(true);
  const [tierLists, setTierLists] = useState({});

  useEffect(() => {
    const fetchTierListByGenre = async (genreId) => {
      try {
        // Get Reference
        const tierListRef = collection(db, "tierLists");
        // Create a query
        const queryString = genreId;
        const genreRef = doc(db, "formGenres", queryString);
        const q = query(
          tierListRef,
          where("genreRef", "==", genreRef),
          where("draft", "==", false),
          limit(10)
        );

        // Execute query
        const querySnap = await getDocs(q);

        const tierListObject = {
          [genreId]: {
            tierLists: [],
          },
        };

        querySnap.forEach((doc) => {
          tierListObject[genreId].tierLists.push({
            id: doc.id,
            data: doc.data(),
          });
          return;
        });
        setLoading(false);
        return tierListObject;
      } catch (error) {
        setLoading(false);
        toast.error("Could not fetch listings");
      }
    };

    const fetchTierLists = () => {
      let newTierListState = {};
      Object.keys(genres).forEach((genreId) => {
        fetchTierListByGenre(genreId).then((res) => {
          newTierListState = {
            ...newTierListState,
            ...res,
          };
          console.log("newTierListState :", newTierListState);
          setTierLists(newTierListState);
        });
      });
    };

    if (Object.entries(genres).length !== 0) {
      fetchTierLists();
    }
  }, [genres]);

  const settings = {
    dots: false,
    accessibility: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Container>
      <Typography variant="h1" component="h1">
        Explore
      </Typography>
      {loading ? (
        <Spinner />
      ) : (
        <List style={{ listStyleType: "none" }}>
          {Object.keys(genres).map((genreId) => {
            return (
              <ListItem
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
                key={genres[genreId].key}
              >
                <Typography variant="h4" component="h4">
                  {genres[genreId].name}
                </Typography>
                <Container>
                  <Slider {...settings}>
                    {tierLists[genreId] !== undefined &&
                      tierLists[genreId].tierLists.map((list) => (
                        <Link to={"/tierlist/" + list.id} key={list.id}>
                          <div>
                            <Typography
                              variant="h5"
                              component="h5"
                              style={{
                                backgroundColor: "#efefef",
                                textAlign: "center",
                                minHeight: "100px",
                                display: "grid",
                                placeItems: "center",
                              }}
                            >
                              {list.data.titleName}
                            </Typography>
                          </div>
                        </Link>
                      ))}
                    {[
                      "1",
                      "2",
                      "3",
                      "4",
                      "5",
                      "6",
                      "7",
                      "8",
                      "9",
                      "10",
                      "11",
                      "12",
                      "13",
                      "14",
                    ].map((num) => (
                      <div key={num}>
                        <Typography
                          variant="h5"
                          component="h5"
                          style={{
                            backgroundColor: "#efefef",
                            textAlign: "center",
                            minHeight: "100px",
                            display: "grid",
                            placeItems: "center",
                          }}
                        >
                          {num}
                        </Typography>
                      </div>
                    ))}
                  </Slider>
                </Container>
              </ListItem>
            );
          })}
        </List>
      )}
    </Container>
  );
}

export default Explore;
